import React from "react";

interface IHomeProps {

}

const Home = (props:IHomeProps) => {

    return (
        <div>
            Home
        </div>
    )
};

export default Home;
